export function MediaSlice({
  primary,
}: {
  primary: { video: { url: string } };
}) {
  return (
    <video
      className="my-md"
      width="100%"
      height="100%"
      autoPlay
      controls
      muted
      loop
      playsInline
      {...{ 'webkit-playsinline': 1, 'x5-playsinline': 1 }}
    >
      <source src={primary.video.url} type="video/mp4" />
      Sorry, your browser doesn&apos;t support embedded videos.
    </video>
  );
}
